import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import { Modal, Form, Input, Select, Switch, InputNumber, DatePicker, Radio, Divider, TreeSelect, } from "antd";
// 导入 ValidateMessages 类型
// import type { ValidateMessages } from 'rc-field-form/lib/interface';
const { Option } = Select;
const { TextArea } = Input;
const { Group: RadioGroup } = Radio;
/**
 * 通用表单模态框组件
 */
const GenericModalForm = ({ title, visible, width = 600, formItems, formRef, initialValues = {}, onCancel, onSubmit, okText = "确定", cancelText = "取消", formProps, modalProps, validateMessages, layout = "horizontal", // 默认为水平布局，label 在左侧
labelCol = { span: 6 }, // 默认标签宽度
wrapperCol = { span: 18 }, // 默认内容区域宽度
 }) => {
    const [form] = Form.useForm();
    // 将表单实例传递给父组件
    // 优化表单实例传递
    useEffect(() => {
        if (formRef && form) {
            // 添加调试日志
            console.log("传递表单实例到父组件");
            formRef(form);
        }
    }, [form, formRef]);
    // 使用ref跟踪表单是否已经初始化
    const formInitializedRef = useRef(false);
    // 当visible或initialValues变化时重置表单
    useEffect(() => {
        if (visible) {
            // 安全处理 initialValues，确保不是 null 或 undefined
            const safeInitialValues = initialValues || {};
            // 如果有初始值，设置表单值
            if (Object.keys(safeInitialValues).length > 0) {
                form.setFieldsValue(safeInitialValues);
                formInitializedRef.current = true;
            }
            else if (!formInitializedRef.current) {
                // 只有在表单未初始化时才重置和清空
                form.resetFields();
                // 确保表单完全清空 - 添加正确的类型注解
                const emptyValues = {}; // 修改此处添加类型
                formItems.forEach((item) => {
                    // 确保item.name是字符串类型
                    if (typeof item.name === "string") {
                        emptyValues[item.name] = undefined;
                    }
                });
                form.setFieldsValue(emptyValues);
                formInitializedRef.current = true;
            }
            // 调试日志已移除
        }
        else {
            // 当模态框关闭时，重置初始化标志
            formInitializedRef.current = false;
        }
    }, [visible, initialValues, form, formItems]);
    // 渲染表单控件
    // 修改 renderFormItem 函数以添加对 treeSelect 类型的支持
    // 渲染表单控件
    const renderFormItem = (item) => {
        const { type, options, props = {} } = item;
        switch (type) {
            case "input":
                return _jsx(Input, { ...props });
            case "textarea":
                return _jsx(TextArea, { rows: 4, ...props });
            case "select":
                return (_jsx(Select, { ...props, children: options?.map((opt) => (_jsx(Option, { value: opt.value, children: opt.label }, opt.value))) }));
            case "treeSelect":
                return (_jsx(TreeSelect, { showSearch: true, style: { width: "100%" }, dropdownStyle: { maxHeight: 400, overflow: "auto" }, placeholder: "\u8BF7\u9009\u62E9", allowClear: true, treeDefaultExpandAll: true, treeNodeFilterProp: "title", ...props }));
            case "switch":
                return _jsx(Switch, { ...props });
            case "number":
                return _jsx(InputNumber, { style: { width: "100%" }, ...props });
            case "date":
                return _jsx(DatePicker, { style: { width: "100%" }, ...props });
            case "radio":
                return (_jsx(RadioGroup, { ...props, children: options?.map((opt) => (_jsx(Radio, { value: opt.value, children: opt.label }, opt.value))) }));
            case "custom":
                const CustomComponent = item.customComponent;
                return CustomComponent ? (_jsx(CustomComponent, { ...props })) : (_jsx(Input, { ...props }));
            default:
                return _jsx(Input, { ...props });
        }
    };
    // 根据布局模式准备表单属性
    const layoutFormProps = {
        layout,
        ...(layout === "horizontal" ? { labelCol, wrapperCol } : {}),
    };
    return (_jsx(Modal, { title: title, open: visible, width: width, onCancel: onCancel, onOk: () => {
            form
                .validateFields()
                .then(async (values) => {
                try {
                    // 执行提交并等待可能的 Promise 结果
                    const result = await Promise.resolve(onSubmit(values));
                    // 关闭模态框(无论返回结果如何，除非返回明确的 false)
                    if (result !== false) {
                        onCancel();
                    }
                }
                catch (error) {
                    console.error("表单提交失败:", error);
                }
            })
                .catch((info) => {
                console.log("表单验证失败:", info);
            });
        }, okText: okText, cancelText: cancelText, destroyOnClose: true, ...modalProps, children: _jsx(Form, { form: form, initialValues: initialValues, validateMessages: validateMessages, autoComplete: "off", onFinish: onSubmit, ...layoutFormProps, ...formProps, style: {
                margin: "32px",
                display: visible ? "block" : "none",
            }, children: formItems.map((item) => {
                // 处理分隔线类型
                if (item.type === "divider") {
                    return (_jsx(Divider, { orientation: "left", style: { marginTop: 24, marginBottom: 16 }, children: _jsx("span", { style: { fontWeight: "bold" }, children: item.label }) }, item.name));
                }
                // 处理普通表单项
                return (_jsx(Form.Item, { name: item.name, label: item.label, rules: item.rules, valuePropName: item.type === "switch" ? "checked" : "value", hidden: item.hidden === true, dependencies: item.dependencies, children: renderFormItem(item) }, item.name));
            }) }) }));
};
export default GenericModalForm;
